import React, { useState } from 'react'
import { ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap'
import { SplitButtonDropdownProp } from '../../../../Type/Ui-Kits/UiKitsTypes';
import { Btn } from '../../../../AbstractElements';
import { Link } from 'react-router-dom';
import { Href } from '../../../../utils/Constant';

const SplitButtonDropdown:React.FC<SplitButtonDropdownProp> = ({ item }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <ButtonGroup>
      <Btn outline color={item.btnColor}>{item.btnText}</Btn>
      <Dropdown className="separated-btn" isOpen={open} toggle={toggle}>
        <DropdownToggle color={item.btnColor}>
          <i className="icofont icofont-arrow-down"></i>
        </DropdownToggle>
        <div className="dropdown-content">
          {item.items.map((data, index) => (
            <Link to={Href} key={index}>{data.item}</Link>
          ))}
        </div>
      </Dropdown>
    </ButtonGroup>
  )
}

export default SplitButtonDropdown